import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { RosterAssignment } from "@app/models/rest/roster/roster-assignment";
import { RosterAssignmentRestService } from "@app/services/hal/roster/roster-assignment-rest-service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class RosterAssignmentStore extends RealTimeDataStore<RosterAssignment> {
  constructor() {
    const rosterAssignmentRestService = inject(RosterAssignmentRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      rosterAssignmentRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("RosterAssignment");
  }
}
